<template>
  <IconTooltip
    v-if="mfaStatus !== mfaStates.inactive"
    :contentContainerClass="$style.contentContainer"
    :iconClass="iconClass"
  >
    <div :class="$style.tooltipContent">
      <div v-if="mfaStatus === mfaStates.active">
        <div>
          This user, <strong>{{ getDisplayName(item) }}</strong>,
          has successfully completed TOTP MFA setup.
        </div>
        <div v-if="!item.enable_user_portal_multifactor">
          * MFA <strong>isn’t currently required</strong> for their User Portal.
        </div>
      </div>
      <div v-if="mfaStatus === mfaStates.enrollment">
        <div v-if="item.state === staged">
          <strong>{{ getDisplayName(item) }}'s</strong>
          TOTP (Verification Code) enrollment starts when their user state changes
          to active.
        </div>
        <div v-else>
          This user, <strong>{{ getDisplayName(item) }}</strong>,
          is in TOTP MFA enrollment until
          <strong :class="$style.pending">{{ enrollmentDateFormatted }}</strong>.
          You can Reset TOTP MFA for this user to extend enrollment.
          <div v-if="!item.enable_user_portal_multifactor">
            * MFA <strong>isn’t currently required</strong> for their User Portal.
          </div>
        </div>
      </div>
      <div v-if="mfaStatus === mfaStates.enrollmentExpired">
        This user, <strong>{{ getDisplayName(item) }}'s</strong>, TOTP MFA enrollment period
        <span v-if="enrollmentDateFormatted">
          expired <strong :class="$style.locked">{{ enrollmentDateFormatted }}</strong>.
        </span>
        <span v-else>
          expired.
        </span>
        You can Reset TOTP MFA to restart their enrollment period.
      </div>
    </div>
  </IconTooltip>
</template>

<script>
import { ModuleConsts } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import IconTooltip from 'components/Tooltip/IconTooltip.vue';
import UserItemStates from 'components/mixins/UserItemStates';
import moment from 'moment';

const { mfaStates } = ModuleConsts.systemUser;
const { staged } = ModuleConsts.systemUser.accountStates;

export default {
  name: 'SystemUserMFAIcon',

  components: {
    IconTooltip,
  },

  mixins: [UserItemStates],

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    mfaStates,
    staged,
  }),

  computed: {
    ...mapGetters('SystemUserCollection', {
      getDisplayName: 'getDisplayName',
    }),

    enrollmentDate() {
      return (this.item.mfa && this.item.mfa.exclusionUntil)
        ? moment(this.item.mfa.exclusionUntil) : '';
    },

    enrollmentDateFormatted() {
      return this.enrollmentDate ? this.enrollmentDate.format('M-D-YYYY') : '';
    },

    iconClass() {
      const iconClasses = [this.$style.icon];
      if (this.mfaStatus === mfaStates.enrollmentExpired) {
        iconClasses.push('jc-mfa-locked', this.$style.locked);
      } else if (this.mfaStatus === mfaStates.active) {
        if (this.item.enable_user_portal_multifactor) {
          iconClasses.push('jc-mfa-active-up', this.$style.active);
        } else {
          iconClasses.push('jc-mfa-active', this.$style.active);
        }
      } else {
        iconClasses.push('jc-mfa-pending', this.$style.pending);
      }
      return iconClasses;
    },
  },
};
</script>

<style module>
@value (errorRed, jcGreen, jcOrange) from '~css/colors.css';

.icon {
  font-size: 18px;
}

.contentContainer {
  left: -37px;
  top: -36px;
}

[x-placement="left"] .contentContainer {
  right: -37px;
}

.active { color: jcGreen; }
.pending { color: jcOrange; }
.locked { color: errorRed; }
</style>
